import type { ComponentProps } from "react";

import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

const SIZE_MAP = {
  xs: 12,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
} as const;

type SpinnerSize = keyof typeof SIZE_MAP;

type LoaderProps = Omit<ComponentProps<typeof Loader2>, "size">;

type SpinnerProps = LoaderProps & {
  size?: SpinnerSize;
};

export function Spinner({
  size = "md",
  className,
  "aria-label": ariaLabel = "Loading",
  ...props
}: SpinnerProps) {
  const pixelSize = SIZE_MAP[size];

  return (
    <Loader2
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
      size={pixelSize}
      className={cn("animate-spin", className)}
      {...props}
    />
  );
}
